"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureDefaults = exports.Feature = exports.useFeatureContext = exports.FeatureProvider = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var internal_tracker_1 = require("../internal-tracker");
var featureDefaults = {
    helloWorldWelcome: false,
    billingHistoryCallout: false,
    hideRecommendedDirectDebit: false,
    suggestedPayments: false,
    showPredictedDebtChip: false,
    expandFirstBillingPeriod: false,
    moveOutCTA: 'control',
    omrWithoutMsn: false,
    meterSummary: false,
    hideUsageCostAfterOctober: false,
    removeSolarInverter: false,
    billingComprehension: 'control',
    meterPhoto: false,
    locationScopeDashboardPrompt: false,
    osv1Download: false,
};
exports.featureDefaults = featureDefaults;
var _b = (0, ui_tools_1.createFeatureTooling)(featureDefaults, {
    name: 'FeatureVariant',
    type: 'render',
    properties: (_a = {},
        _a[internal_tracker_1.INTERNAL_EVENT_FLAG] = true,
        _a),
}), FeatureProvider = _b.FeatureProvider, useFeatureContext = _b.useFeatureContext, Feature = _b.Feature;
exports.FeatureProvider = FeatureProvider;
exports.useFeatureContext = useFeatureContext;
exports.Feature = Feature;
